import { ref } from 'vue';

// The merged timeline replaces the message area in place, but it is opened from the contact panel,
// a sibling of the conversation box - shared module state instead of routing an event through both.
const isContactTimelineOpen = ref(false);

export function useContactTimeline() {
  const openContactTimeline = () => {
    isContactTimelineOpen.value = true;
  };

  const closeContactTimeline = () => {
    isContactTimelineOpen.value = false;
  };

  return { isContactTimelineOpen, openContactTimeline, closeContactTimeline };
}
